var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PurchaseTable',{attrs:{"query-type":"order"}})
}
var staticRenderFns = []

export { render, staticRenderFns }